import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ISpecificBrickSettingsComponent } from 'src/app/components/dashboard/brick-settings/brick-specific-type-settings/ISpecificBrickSettingsComponent';
import { ChangeJsonConfiguration } from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/dynamic-actions-brick-settings/dynamic-actions-brick-settings.actions';
import { DynamicActionsBrickSettingsState } from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/dynamic-actions-brick-settings/dynamic-actions-brick-settings.state';

@Component({
   selector: 'samweb-dynamic-actions-brick-settings',
   templateUrl: './dynamic-actions-brick-settings.component.html',
   styleUrls: ['./dynamic-actions-brick-settings.component.scss'],
})
export class DynamicActionsBrickSettingsComponent implements OnInit, ISpecificBrickSettingsComponent {
   public brickInstanceId: string;
   public jsonConfiguration$: Observable<string>;

   constructor(private store: Store) {}

   ngOnInit(): void {
      this.jsonConfiguration$ = this.store.select(DynamicActionsBrickSettingsState.getJsonConfigurationFn).pipe(map((fn) => fn(this.brickInstanceId)));
   }

   jsonConfigurationChanged(value: string) {
      this.store.dispatch(new ChangeJsonConfiguration(this.brickInstanceId, value));
   }
}
